import { globalState } from '../internal/stateContainer';
import { useSelector } from './useSelector';
export var useConnectedUser = function () {
    useSelector(function (state) { var _a; return (_a = state.connectedUser) === null || _a === void 0 ? void 0 : _a.email; });
    useSelector(function (state) { var _a; return (_a = state.connectedUser) === null || _a === void 0 ? void 0 : _a.key; });
    return globalState.connectedUser;
};
//# sourceMappingURL=useConnectedUser.js.map